import { render } from "./BasePageBackButton.vue?vue&type=template&id=1fa776da&scoped=true"
import script from "./BasePageBackButton.vue?vue&type=script&lang=js"
export * from "./BasePageBackButton.vue?vue&type=script&lang=js"

import "./BasePageBackButton.vue?vue&type=style&index=0&id=1fa776da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa776da"],['__file',"src/components/helpers/BasePageBackButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1fa776da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1fa776da', __exports__)) {
    api.reload('1fa776da', __exports__)
  }
  
  module.hot.accept("./BasePageBackButton.vue?vue&type=template&id=1fa776da&scoped=true", () => {
    api.rerender('1fa776da', render)
  })

}


export default __exports__